<template>
  <section>
    <gs-header title="Quản lý role">
      <router-link :to="{ name: 'new-role' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="roleTable" :table-name="roleTable" data-source="roles" :data-params="filters" :data-sorted="sorted"
        :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">

        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[roleTable]">{{ (scope.$index + 1) + ((dataPaginations[roleTable].current_page
                  - 1) * dataPaginations[roleTable].per_page) }}</small>
              </template>
            </el-table-column>

            <el-table-column label="Tên" width="200">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Tên hiển thị" width="200">
              <template slot-scope="scope">
                <p>{{ scope.row.display_name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Mô tả">
              <template slot-scope="scope">
                <p>{{ scope.row.description }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Tạo lúc">
              <template slot-scope="scope">
                <p>{{ scope.row.created_at }}</p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline">
                    <a @click.prevent="detailRole(scope.row)"
                      class="text-blue padding-all display-inline-block cursor-pointer"><i class="fa fa-search"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-role', params: { id: scope.row.id } }"><i
                        class="fa fa-pencil-square-o"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a @click.prevent="deleteRole(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
      <el-dialog :title="`Chi tiết role: ${role.name}(${role.display_name})`" :visible.sync="detailModal">
        <el-row :gutter="20">
          <el-col :span="12">
            <p class="text-center text-gray">Danh sách admin</p>
            <el-table v-if="role.users" :data="role.users.data" border style="width: 100%">
              <el-table-column type="index" width="40">
              </el-table-column>
              <el-table-column prop="name" label=" Tên">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12">
            <p class="text-center text-gray">Danh sách permission</p>
            <el-table v-if="role.permissions" :data="role.permissions.data" border style="width: 100%">
              <el-table-column type="index" width="40">
              </el-table-column>
              <el-table-column prop="name" label=" Tên">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash'
import ls from 'local-storage'
import { deleteRole } from 'src/api/roles'
import { mapGetters, mapActions } from 'vuex'
export default {

  name: 'Role',

  data() {
    return {
      roleTable: 'roles',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      detailModal: false
    }
  },
  computed: {
    ...mapGetters('role', ['role'])
  },
  methods: {
    ...mapActions('role', ['getRole', 'setRole']),
    removeFilter() {
      this.reloadGsTable(this.roleTable)
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.roleTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.roleTable)
      }
    }, 300),
    deleteRole(role) {
      this.setRole(role)
      this.$confirm(`Bạn chắc chắn muốn xóa role ${this.role.name}`, 'Xóa role', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delRole()
      }).catch(() => {

      })
    },
    delRole() {
      deleteRole(this.role.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa role thành công'
          })
          this.reloadGsTable(this.roleTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa role thất bại'
          })
        }
      })
    },
    detailRole(role) {
      this.detailModal = true
      this.getRole({ id: role.id, params: { include: 'users,permissions' } })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.roleTable]) {
      this.filters = ls.get('filters')[this.roleTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.roleTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['roles']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Role.vue?5f69ae32